var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5926 20.3893V12.7068C36.5926 11.2718 35.5076 9.64426 34.1601 9.10176L24.4126 5.11176C22.2251 4.21926 19.7576 4.21926 17.5701 5.11176L7.82259 9.10176C6.49259 9.64426 5.40759 11.2718 5.40759 12.7068V20.3893C5.40759 28.9468 11.6201 36.9618 20.1076 39.3068C20.6851 39.4643 21.3151 39.4643 21.8926 39.3068C30.3801 36.9618 36.5926 28.9468 36.5926 20.3893ZM22.3126 23.4518V28.0543C22.3126 28.7718 21.7176 29.3668 21.0001 29.3668C20.2826 29.3668 19.6876 28.7718 19.6876 28.0543V23.4518C17.9201 22.8918 16.6251 21.2468 16.6251 19.3043C16.6251 16.8893 18.5851 14.9293 21.0001 14.9293C23.4151 14.9293 25.3751 16.8893 25.3751 19.3043C25.3751 21.2643 24.0801 22.8918 22.3126 23.4518Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.d4013d83ff0bd093ee259be145ea7a16.svg";
export { ForwardRef as ReactComponent };